import React from 'react'
import PropTypes from 'prop-types'

const Item = ({ description, children }) => (
  <div className='extract-item col-12'>
    <div className='row'>
      <div className='col-auto mr-auto'>
        <p className='txt-body-sm'>{description}</p>
      </div>
      <div className='col-auto ml-auto'>
        <p className='txt-body-sm'>{children}</p>
      </div>
    </div>
  </div>
)

Item.propTypes = {
  description: PropTypes.string.isRequired,
  children: PropTypes.element.isRequired
}

export default Item



// WEBPACK FOOTER //
// ./src/Participant/Extract/Totalizers/Item.js